<template>
  <div class="text-sm text-gray-500">{{ totalResults }} results</div>
</template>
<script setup lang="ts">
  import {toRefs} from 'vue';

  const props = withDefaults(
    defineProps<{
      totalResults: number;
    }>(),
    {
      totalResults: 0,
    }
  );

  const {totalResults} = toRefs(props);
</script>
